import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import _ from 'lodash';

@Component({
    selector: 'fe-form-control-feedback, [fe-form-control-feedback]',
    templateUrl: './form-control-feedback.component.html',
    styleUrls: ['./form-control-feedback.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FormControlFeedbackComponent {
    @Input() errors!: ValidationErrors | null | undefined;

    @Input() flowPage = 'core_errors';

    @Input() renderComponentInvalid = false;

    public getControlErrors(): { error: string; reason: unknown }[] {
        if (!this.errors) {
            return [];
        }
        const errors: { error: string; reason: unknown }[] = [];
        Object.keys(this.errors).forEach((key) => {
            errors.push({
                error: key,
                reason: _.get(this.errors, key, ''),
            });
        });
        return errors;
    }

    public trackByFnErrors(index: number, item: any): number {
        return index;
    }
}
